import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";

const CreateRestaurantPage = () => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [type, setType] = useState("");
  const [price, setPrice] = useState("");
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form fields
    if (!name || !description || !city || !country || !type || !price || !image) {
      setError("يرجى ملء جميع الحقول.");
      return;
    }

    setLoading(true);
    setError(null);
    setSuccessMessage("");

    try {
      const docRef = await addDoc(collection(db, "restaurants"), {
        name,
        description,
        city,
        country,
        type,
        price: parseFloat(price),
        image,
        createdAt: new Date(),
      });
      setSuccessMessage("تم إضافة المطعم بنجاح!");
      setName("");
      setDescription("");
      setCity("");
      setCountry("");
      setType("");
      setPrice("");
      setImage("");
    } catch (error) {
      console.error("Error adding restaurant:", error);
      setError("فشل إضافة المطعم. يرجى المحاولة مرة أخرى.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-center mb-6">إضافة مطعم جديد</h1>

      {error && <p className="text-red-500 text-center mb-4">{error}</p>}
      {successMessage && <p className="text-green-500 text-center mb-4">{successMessage}</p>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="name" className="block font-semibold">اسم المطعم</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md"
            required
          />
        </div>

        <div>
          <label htmlFor="description" className="block font-semibold">الوصف</label>
          <textarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md"
            required
          />
        </div>

        <div className="flex space-x-4">
          <div className="flex-1">
            <label htmlFor="city" className="block font-semibold">المدينة</label>
            <input
              type="text"
              id="city"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          <div className="flex-1">
            <label htmlFor="country" className="block font-semibold">الدولة</label>
            <input
              type="text"
              id="country"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>
        </div>

        <div>
          <label htmlFor="type" className="block font-semibold">نوع المطعم</label>
          <select
            id="type"
            value={type}
            onChange={(e) => setType(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md"
            required
          >
            <option value="">اختر النوع</option>
            <option value="Fast Food">وجبات سريعة</option>
            <option value="Fine Dining">طعام فاخر</option>
            <option value="Casual Dining">طعام عادي</option>
            <option value="Cafe">مقهى</option>
            <option value="Others">أخرى</option>
          </select>
        </div>

        <div>
          <label htmlFor="price" className="block font-semibold">نطاق السعر</label>
          <input
            type="number"
            id="price"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md"
            required
          />
        </div>

        <div>
          <label htmlFor="image" className="block font-semibold">رابط الصورة</label>
          <input
            type="text"
            id="image"
            value={image}
            onChange={(e) => setImage(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md"
            required
          />
        </div>

        <button
          type="submit"
          className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600 transition duration-300"
          disabled={loading}
        >
          {loading ? "جاري الإضافة..." : "إضافة المطعم"}
        </button>
      </form>
    </div>
  );
};

export default CreateRestaurantPage;
